import React from 'react';
import BackgroundImageWrapper from './BackgroundImageWrapper';
import cwrGroup from '../assets/img/cwr_group.jpg';
import cwsGroup from '../assets/img/cws_group.jpg';

const CampSiteLinks = props => {
    return (
        <div className="CampSiteLinks">
            <BackgroundImageWrapper height="50vh" image={cwsGroup}>
                <a
                    href="http://www.campwillowsprings.org"
                    target="_blank"
                    className="link">
                    <div className="text">
                        <h1>CAMP WILLOW SPRINGS</h1>
                    </div>
                </a>
            </BackgroundImageWrapper>
            <BackgroundImageWrapper height="50vh" image={cwrGroup}>
                <a
                    href="http://www.campwillowrun.org"
                    target="_blank"
                    className="link">
                    <div className="text">
                        <h1>CAMP WILLOW RUN</h1>
                    </div>
                </a>
            </BackgroundImageWrapper>
        </div>
    );
};

export default CampSiteLinks;



// WEBPACK FOOTER //
// ./src/components/CampSiteLinks.js